(function() {
    var currentTitle = '';
    var successHtml = `
      <div class="success">
        <div class="success-animation">
          <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none" /><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" /></svg>
        </div>
        <h2>Congratulations</h2>
        <p>You have successfully subscribed</p>
        <button class="ok btn">Get it</button>
      </div>
    `
    var formHtml = `
      <form style="width: 100%;">
        <div data-field-name="email" class="input-row">
          <label>Email Address</label>
          <input type="text" placeholder="" name="email" autocomplete="off" style="margin-top: 12px;">
        </div>

        <button class="submit btn" disabled>Submit</button>
      </form>
    `
    var dialogHtml = `
      <div class="dialog" data-dialog="subscribe" >
        <div class="mask"></div>
        <div class="body" style="transform: scale(0) translate(-50%, -50%);">
          <div class="close">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 10.5862L16.95 5.63623L18.364 7.05023L13.414 12.0002L18.364 16.9502L16.95 18.3642L12 13.4142L7.04999 18.3642L5.63599 16.9502L10.586 12.0002L5.63599 7.05023L7.04999 5.63623L12 10.5862Z" fill="white"></path>
            </svg>
          </div>
          ${formHtml}
        </div>
      </div>
    `
  
    function close(params) {
      $('.dialog[data-dialog="subscribe"] .body').css('transform', 'scale(0) translate(-50%, -50%)')
       var timer = setTimeout(() => {
        $('.dialog[data-dialog="subscribe"]').remove()
        clearTimeout(timer)
      }, 300)
    }
    
    $('body').on('click', '.lightly-spaced-row-above .btn', function(event){
      currentTitle = event.target.dataset?.titleText;
      event.preventDefault();
      $('body').append(dialogHtml)
      var timer = setTimeout(() => {
        $('.dialog[data-dialog="subscribe"] .body').css('transform', 'scale(1) translate(-50%, -50%)')
        clearTimeout(timer)
      }, 0)
    })
  
    $('body').on('click', '.dialog[data-dialog="subscribe"] .mask', function(){
      close()
    })
  
    $('body').on('click', '.dialog[data-dialog="subscribe"] .close', function(){
      close()
    })
  
    $('body').on('click', '.dialog[data-dialog="subscribe"] .ok', function(){
      close()
    })
  
    $('body').on('input', '.dialog[data-dialog="subscribe"] form input', function(){
      $(this).parent().removeAttr('data-error')
      var formArray = $('.dialog[data-dialog="subscribe"] form').serializeArray()
      var formObject = {};
      $(formArray).each(function(index, obj){
          formObject[obj.name] = obj.value;
      });
      if ($(`.dialog[data-dialog="subscribe"] form`).find("[data-error]").length > 0) {
        $('.dialog[data-dialog="subscribe"] form .submit').prop('disabled', true);
        return 
      }
      if (formObject.email) {
        $('.dialog[data-dialog="subscribe"] form .submit').prop('disabled', false);
      } else {
        $('.dialog[data-dialog="subscribe"] form .submit').prop('disabled', true);
      }
    })
  
    $('body').on('click', '.dialog[data-dialog="subscribe"] .submit', function(event){
      event.preventDefault();
      $(this).prop('disabled', true);
      var formArray = $('.dialog[data-dialog="subscribe"] form').serializeArray()
      var formObject = {};
      $(formArray).each(function(index, obj){
          formObject[obj.name] = obj.value;
      });
      var {email} = formObject
      var _this = this
      var urlTag = new URLSearchParams(new URL(window.location.href).search).get('tag');
      if (urlTag) currentTitle = urlTag;
       $.ajax({
          url: `https://dtc.piscifun.com/api/user/subscription?shop_id=3&email=${email}&name=&phone=&zip_code=&address=&tags=${currentTitle || ''}`,
          success: (data) => {
            if (data.code === 200) {
              $(`.dialog[data-dialog="subscribe"] form`).remove()
              $(`.dialog[data-dialog="subscribe"] .body`).append(successHtml)
            } else if (data.code === 201) {
              $(`.dialog[data-dialog="subscribe"] form div[data-field-name="email"]`).attr('data-error', data.msg||'Your email address has been subscribed')
            } else if (data.code === 0) {
              try {
                var json = JSON.parse(data.msg)
                if (json.errors) {
                  $.each(json.errors, function(key, value){
                    let msg = value[0];
                    if (msg === 'is invalid' && key === 'email') msg = 'Please enter valid Email address';
                      $(`.dialog[data-dialog="subscribe"] form div[data-field-name="${key}"]`).attr('data-error', msg)
                  });
                }
              } catch (error) {
                
              }
            } else {
              
            }
           $(_this).prop('disabled', true);
          },
          error: () => {
            var timer = setTimeout(() => {
              $(this).prop('disabled', false);
              clearTimeout(timer)
            }, 500)
          }
        });
      })
    
  })();